import React from 'react'
import { Text } from '@workwhile/ui'
import { formatDate, formatDistanceToNowStrict } from 'date-fns'

type DateWithRelativeTimeProps = {
  date: string
  // 'stacked' renders the relative time on its own line below the date (used for tables
  // with dedicated Created At / Updated At columns). 'inline' renders it on the same line
  // (used for tables with a single combined date column).
  variant?: 'stacked' | 'inline'
}

export const DateWithRelativeTime = ({
  date,
  variant = 'stacked',
}: DateWithRelativeTimeProps) => {
  const shortDate = formatDate(date, 'MMM, dd, yyyy')
  const fullDateTime = formatDate(date, 'MMM, dd, yyyy, hh:mm a')
  const distance = formatDistanceToNowStrict(date, { addSuffix: true })

  if (variant === 'inline') {
    return (
      <Text as="span" title={fullDateTime}>
        {shortDate} ({distance})
      </Text>
    )
  }

  return (
    <>
      <Text title={fullDateTime}>{shortDate}</Text>
      <Text color="lightText">({distance})</Text>
    </>
  )
}
